import {ITagModel} from '../tag/TagModel'

export const HR_CALL_POOL_PATH = '/hr/call-pool'

/** CallPoolEntryDto */
export interface ICallPoolEntryModel {
  id: string
  candidateId: string
  firstname: string
  lastname: string
  email?: string | null
  phone?: string | null
  candidateLocation?: string | null
  tags?: ITagModel[]
  /** Başvurular ekranından aktarıldıysa kaynak başvuru ve ilanı */
  applyJobId?: string | null
  jobTitle?: string | null
  assignedUserId: string
  assignedUserName?: string | null
  assignedBy?: string | null
  status: 'WAITING' | 'CALLED'
  createdDate?: string
}

/** CallJobOptionDto */
export interface ICallJobOption {
  jobId: string
  title: string
  subTitle?: string | null
  locations?: string | null
  /** Aday bu ilana başvurmuş (yeşil etiket) */
  applied: boolean
  /** Bu ilan için süreç zaten başlatılmış; seçilemez */
  trackingStarted: boolean
  /** İlana adımları tanımlı süreç bağlı; değilse süreç başlatılamaz */
  hasProcess: boolean
}

/** Firma kullanıcısı (gateway /corporate/profile/users) */
export interface ICorporateUserOption {
  userId: string
  username: string
  email: string
  firstName?: string | null
  lastName?: string | null
}

export const userDisplayName = (user: ICorporateUserOption) =>
  [user.firstName, user.lastName].filter(Boolean).join(' ') || user.username

export type AssignMode = 'SELF' | 'USER' | 'RANDOM'

export interface IAssignRequest {
  candidateIds?: string[]
  applicationIds?: string[]
  mode: AssignMode
  assignee?: {userId: string; name: string}
  users?: {userId: string; name: string}[]
}

export const NEGATIVE_REASONS: {value: string; label: string}[] = [
  {value: 'NOT_REACHED', label: 'Ulaşılamadı'},
  {value: 'NOT_INTERESTED', label: 'İlgilenmiyor'},
  {value: 'SALARY_MISMATCH', label: 'Ücret beklentisi uyuşmuyor'},
  {value: 'NOT_QUALIFIED', label: 'Nitelikleri uygun değil'},
  {value: 'LOCATION_MISMATCH', label: 'Lokasyon uygun değil'},
  {value: 'FOUND_ANOTHER_JOB', label: 'Başka bir iş buldu'},
  {value: 'OTHER', label: 'Diğer'},
]

/** CallLogDto (aday künyesindeki arama kayıtları) */
export interface ICallLogModel {
  id: string
  result: 'POSITIVE' | 'NEGATIVE'
  negativeReason?: string | null
  negativeReasonLabel?: string | null
  salaryExpectation?: string | null
  startedJobs?: string | null
  note?: string | null
  calledByUserName?: string | null
  createdDate?: string
}

/** Künye adresine eklenir; künye bu kayıt için Olumlu / Olumsuz butonlarını gösterir */
export const CALL_ENTRY_PARAM = 'callEntry'
